// extracted by mini-css-extract-plugin
module.exports = {"list":"PostList_list__2Pq7Y","recents":"PostList_recents__swOfQ"};